module.exports = __webpack_public_path__ + "6b3345c1a7d57c198ba69403484d1f4b.svg";